import { c as _c } from "react/compiler-runtime";
import type { SameTenantDupe } from '@onefootprint/request-types/dashboard';
import { Tag } from '@onefootprint/ui';
import StatusBadge from '@/components/status-badge';
import getTruncatedName from '@/utils/get-truncated-name';
import useDupeKindLabels from '../../hooks/use-dupe-kind-labels';
type MobileRowProps = {
  duplicateDataItem: SameTenantDupe;
};
const MobileRow = t0 => {
  const $ = _c(29);
  const {
    duplicateDataItem
  } = t0;
  const {
    dupeKinds,
    fpId,
    status,
    startTimestamp,
    data
  } = duplicateDataItem;
  const dupeKindToTranslation = useDupeKindLabels();
  let t1;
  if ($[0] !== data) {
    t1 = getTruncatedName(data);
    $[0] = data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="min-w-0 text-label-2 text-primary wrap-anywhere">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== status) {
    t3 = <StatusBadge status={status} />;
    $[4] = status;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex items-center justify-between gap-3">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== fpId) {
    t5 = <span className="min-w-0 text-snippet-3 text-tertiary wrap-anywhere">{fpId}</span>;
    $[9] = fpId;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== startTimestamp) {
    t6 = new Date(startTimestamp).toLocaleString("en-us", {
      month: "numeric",
      day: "numeric",
      year: "2-digit",
      hour: "numeric",
      minute: "numeric"
    });
    $[11] = startTimestamp;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <span className="text-body-3 text-tertiary whitespace-nowrap">{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="flex flex-wrap items-center justify-between gap-x-3">{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== dupeKindToTranslation || $[19] !== dupeKinds) {
    let t10;
    if ($[21] !== dupeKindToTranslation) {
      t10 = kind => <Tag key={kind}>{dupeKindToTranslation[kind]}</Tag>;
      $[21] = dupeKindToTranslation;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    t9 = dupeKinds.map(t10);
    $[18] = dupeKindToTranslation;
    $[19] = dupeKinds;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <div className="flex flex-wrap gap-1 pt-1.5">{t9}</div>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t4 || $[27] !== t8) {
    t11 = <td><div className="flex flex-col gap-0.5 py-3 whitespace-normal">{t4}{t8}{t10}</div></td>;
    $[25] = t10;
    $[26] = t4;
    $[27] = t8;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  return t11;
};
export default MobileRow;